import { postAuditTrailExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAuditTrailExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAuditTrailExport',
	receive: true,
	request: true,
	requestHandler: postAuditTrailExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
